import styled, { css } from 'styled-components';
import { HeadingStyle } from 'components/heading';
import { device } from 'commons';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.neutral_100};
  border-radius: 5px;
`;

const iconSize = '26px';

export const ToggleIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${iconSize};
  height: ${iconSize};
  background-color: ${({ theme }) => theme.neutral_200};
  border-radius: 100%;

  svg {
    height: 16px;
    width: 16px;
  }
`;

const wrapperSpacing = {
  gap: '12px',
  padding: '15px',
};

export const Wrapper = styled.button<{ $alignStart: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  width: fit-content;
  left: calc(-${iconSize} - ${wrapperSpacing.gap} - ${wrapperSpacing.padding});
  gap: ${wrapperSpacing.gap};
  padding: ${wrapperSpacing.padding};
  background-color: transparent;
  border-radius: 5px;
  cursor: pointer;

  ${({ $alignStart }) =>
    $alignStart &&
    css`
      left: unset;
      padding-left: 0;
    `};

  &:hover {
    ${ToggleIcon} {
      box-shadow: 0 0 5px ${({ theme }) => theme.neutral_300};
    }
  }

  ${HeadingStyle} {
    color: ${({ theme }) => theme.neutral_500};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  @media (max-width: ${device.mobile}px) {
    ${({ $alignStart }) => !$alignStart && 'flex-direction: row-reverse;'}
    left: unset;
    padding-left: 0;
  }
`;

export const ContentWrapper = styled.div`
  padding-top: 15px;
`;

export const ToggleCheckbox = styled.input`
  &:not(:checked) + ${Main} {
    ${ToggleIcon} {
      svg {
        transform: rotate(270deg);
      }
    }
  }

  &:not(:checked) + ${Main} {
    ${ContentWrapper} {
      display: none;
    }
  }
`;
